import { type Theme } from "@mui/material";

const sharedStyles = (theme: Theme) => ({
  cardContainer: {
    height: "100%",
    width: "100%",
    p: { xs: 1, md: 3 },
    borderWidth: { xs: "1px 0px", sm: "1px" },
    borderRadius: { xs: 0, sm: theme.radius.sm },
  },
  spaceBetweenFlexbox: { display: "flex", justifyContent: "space-between" },
  centerFlexbox: { display: "flex", justifyContent: "center", alignItems: "center", width: "100%", gap: 1 },
  startFlexbox: { display: "flex", justifyContent: "start", width: "100%" },
  secondaryInverseButtonGroup: {
    "& > button:first-of-type.Mui-disabled": {
      borderRight: `3px solid ${theme.palette.border.strong}`,
      borderRightColor: theme.palette.text.secondary,
    },
  },
  secondaryInverseIconButtonGroup: {
    "& > button:first-of-type.Mui-disabled": {
      borderRight: `1px solid ${theme.palette.border.strong}`,
      borderRightColor: theme.palette.text.secondary,
    },
  },
  secondaryInverseButtonGroupButton: {
    borderRadius: theme.radius.xxs,
    border: 1,
    opacity: 1,
    color: theme.palette.secondary.light,
    borderColor: theme.palette.border.default,
    backgroundColor: theme.palette.surface.subtle,
    pointerEvents: "auto",
    "&.Mui-disabled": {
      color: theme.palette.text.secondary,
      borderColor: theme.palette.text.secondary,
      backgroundColor: theme.palette.transparent.pure,
    },
  },
  topNavTitleText: { my: { xs: 1, md: 0 } },
  flexboxRow: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    gap: 1,
    marginTop: 2,
    marginBottom: 2,
  },
  flexboxColStart: {
    flex: "1 1 auto",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    minWidth: 0,
  },
  flexboxColEnd: {
    flex: `1 1 ${theme.spacing(22.5)}`,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 1,
    minWidth: 180,
  },
});

export default sharedStyles;
